import RestService from './RestService';
import { ApiRoutes } from './apiRoutes';
import {
  ConstraintMode,
  ConstraintProfile,
  CreateConstraintProfileRequest,
  PredefinitiAllResponse,
  PredefinitiResponse,
  UpdateConstraintProfileRequest,
} from 'types/ConstraintProfileTypes';

export const ConstraintProfilesService = {
  /** List the advisor's saved profiles for one mode. */
  listProfiles(mode: ConstraintMode): Promise<ConstraintProfile[]> {
    return RestService.get(ApiRoutes.CONSTRAINT_PROFILES, { mode });
  },

  /** Create a new profile. */
  createProfile(data: CreateConstraintProfileRequest): Promise<ConstraintProfile> {
    return RestService.post(ApiRoutes.CONSTRAINT_PROFILES, data, {
      suppressGlobalErrorToast: true,
    });
  },

  /**
   * Update a profile (name / is_default / constraints).
   *
   * No `suppressGlobalErrorToast`: `RestService.put` forwards its 3rd arg as
   * axios `{ params }` (query string), not the request config — the flag would
   * be inert and only leak a stray query param. Callers handle errors locally.
   */
  updateProfile(
    profileId: string,
    data: UpdateConstraintProfileRequest,
  ): Promise<ConstraintProfile> {
    return RestService.put(ApiRoutes.CONSTRAINT_PROFILE(profileId), data);
  },

  /**
   * Delete a profile.
   *
   * No `suppressGlobalErrorToast`: `RestService.delete` forwards its 2nd arg as
   * axios `{ params }` (query string), not the request config — the flag would
   * be inert and only leak a stray query param.
   */
  deleteProfile(profileId: string): Promise<void> {
    return RestService.delete(ApiRoutes.CONSTRAINT_PROFILE(profileId));
  },

  /** Fetch the predefiniti Constraint Document for a mode + financial plan. */
  getPredefiniti(
    mode: ConstraintMode,
    financialPlan: number,
  ): Promise<PredefinitiResponse> {
    return RestService.get(ApiRoutes.CONSTRAINT_PROFILES_PREDEFINITI, {
      mode,
      financial_plan: financialPlan,
    });
  },

  /** Fetch all 8 plans for a mode in one call (session-start bulk prefetch). */
  getPredefinitiAll(mode: ConstraintMode): Promise<PredefinitiAllResponse> {
    return RestService.get(ApiRoutes.CONSTRAINT_PROFILES_PREDEFINITI_ALL, {
      mode,
    });
  },
};
